import { useMenu } from 'src/contexts/menu-context'
import type { MenuSectionProps } from '../../../global-navigation'
import { hasNextLevel, trackMenuPath } from '../../../utils'
import MenuSectionItem from './MenuSectionItem'

export const MenuSection = ({ menu, type }: MenuSectionProps) => {
  const { state, handleDispatch } = useMenu()

  return (
    <div className="pb-2 border-b-2 border-solid border-[#F0F0F0] [&amp;>a:last-child]:mb-0 mb-3">
      {menu?.map((el, index: number) => {
        return hasNextLevel(el) ? (
          <div
            key={`section-item-${index}`}
            className="py-2 flex flex-row gap-3 items-center justify-between mb-1 navigation-link-panel cursor-pointer relative"
            data-category={`data-${el.title}`}
            onClick={() => {
              if (
                type &&
                el.index !== undefined &&
                el.title &&
                el.title !== null
              ) {
                handleDispatch(type, el.index, el.title, Number(type) + 1)
              }
            }}
          >
            <MenuSectionItem item={el} />
          </div>
        ) : (
          <a
            onClick={() => {
              if (
                type &&
                el.index !== undefined &&
                el.title &&
                el.title !== null
              ) {
                handleDispatch(type, el.index, el.title, Number(type))
                trackMenuPath(state, el.title)
              }
            }}
            href={el.titleURL ? el.titleURL : undefined}
            key={`section-item-${index}`}
            className="py-2 flex flex-row gap-3 items-center justify-between mb-1 no-underline"
          >
            <MenuSectionItem item={el} />
          </a>
        )
      })}
    </div>
  )
}
